import { useCallback, useState } from 'react';

import { increase } from '../utils/math';

export function useForceUpdate() {
  const [updates, setUpdates] = useState(0);
  const forceUpdate = useCallback(
    function callback() {
      setUpdates(increase);
    },
    [],
  );

  return {
    updates,
    forceUpdate,
  };
}
